import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  getTelegramNotificationLog,
  getTelegramNotificationState,
} from "@/api/telegramNotifications";

export enum TelegramNotificationQueryKeys {
  State = "telegram-notification-state",
  Log = "telegram-notification-log",
}

export const useTelegramNotificationState = () =>
  useQuery({
    queryKey: [TelegramNotificationQueryKeys.State],
    queryFn: ({ signal }) => getTelegramNotificationState({ signal }),
  });

export const useTelegramNotificationLog = (page: number, pageSize: number) =>
  useQuery({
    queryKey: [TelegramNotificationQueryKeys.Log, page, pageSize],
    queryFn: ({ signal }) =>
      getTelegramNotificationLog({ page, pageSize, signal }),
    placeholderData: keepPreviousData,
  });
